module.exports = __webpack_public_path__ + "static/media/sf-onemarket.c0c2f18a.csv";